module.exports = __webpack_public_path__ + "static/img/Kiitoskortti_Avecor_henripotila_A4.cc88f22.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/salesperson-leaflets/Kiitoskortti_Avecor_henripotila_A4.pdf
// module id = Djnx
// module chunks = 22